import { useEntityTypeOptions } from 'shared/hooks';

export const useEntityTypeLabels = () => {
  const { entityTypeOptions, loading, error } = useEntityTypeOptions();

  return {
    entityTypeLabels: entityTypeOptions?.reduce(
      (labels, { value, name }) => {
        if (!labels[value]) {
          labels[value] = name;
        }
        return labels;
      },
      {} as { [value: string]: string }
    ),
    loading,
    error,
  };
};
